import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import * as FileSaver from 'file-saver';
import { catchError } from 'rxjs/operators';
import { WindowFunctions } from './window.functions';
var FOLDER_QUERY_PARAM = 'organizationUnitId';
var FileDownloadService = /** @class */ (function () {
    function FileDownloadService(_http, _appState) {
        this._http = _http;
        this._appState = _appState;
    }
    FileDownloadService.prototype.download = function (url) {
        var _this = this;
        return this._http.head(url)
            .pipe(
        // retrieve the error message from the server:
        // since HEAD doesn't return a body, we do a GET req
        catchError(function () { return _this._http.get(url); }))
            .subscribe(function () {
            var _a;
            return WindowFunctions.windowHrefRedirect(url, (_a = {},
                _a[FOLDER_QUERY_PARAM] = "" + _this._appState.user.folder.value.id,
                _a));
        });
    };
    FileDownloadService.prototype.downloadStringAsFile = function (filename, mimeType, content) {
        var blob = new Blob([content], { type: mimeType + ";charset=utf-8" });
        FileSaver.saveAs(blob, filename);
    };
    return FileDownloadService;
}());
export { FileDownloadService };
